import * as Location from 'expo-location';
import { useState, useEffect } from 'react';

export interface LocationPermissionStatus {
    hasPermission: boolean;
    loading: boolean;
    error?: string;
}

/**
 * Hook to check and monitor location permission status
 */
export function useLocationPermission(): LocationPermissionStatus {
	const [hasPermission, setHasPermission] = useState(false);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string>();

	const checkPermissionStatus = async () => {
		try {
			setLoading(true);
			setError(undefined);
			const perm = await Location.getForegroundPermissionsAsync();
			setHasPermission(perm.status === 'granted');
		} catch (err) {
			setError(err instanceof Error ? err.message : 'Unknown error');
			setHasPermission(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		let cancelled = false;

		const check = async () => {
			try {
				setLoading(true);
				setError(undefined);
				const perm = await Location.getForegroundPermissionsAsync();
				if (!cancelled) {
					setHasPermission(perm.status === 'granted');
				}
			} catch (err) {
				if (!cancelled) {
					setError(err instanceof Error ? err.message : 'Unknown error');
					setHasPermission(false);
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		};

		check();

		return () => {
			cancelled = true;
		};
	}, []);

	return { hasPermission, loading, error };
}
